import {
	CREATE_SETTLEMENTRATES_FAILURE,
	FETCH_SETTLEMENTRATE_SUCCESS,
	FETCH_SETTLEMENTRATES_SUCCESS,
	SELECT_SETTLEMENTRATE,
	SETTLEMENTRATE_UPDATE
} from "./actions";

const initialState = {
	currently_loading_settlementRates: false,
	settlementRates_in_current_page: [],
	current_page: 0,
	total_settlementRates: 0,
	total_pages: 0,
	new_settlementRate_error: null,
	new_settlementRate_request: {
		settlementRate_name: null,
		ticker: null,
		risk_assessment_date: null,
		notes:null
	},
	selected_settlementRate: {}
};


const reducerDandO = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_SETTLEMENTRATES_SUCCESS:
			return {
				...state,
				current_page: action.page,
				settlementRates_in_current_page: action.data,
				total_pages: action.total_pages
			};
		case SELECT_SETTLEMENTRATE:
			return {...state, selected_settlementRate: {id: action.id}};
		case FETCH_SETTLEMENTRATE_SUCCESS:
			let response = action.data;
			return {
				...state, selected_settlementRate: {
					id: action.id,
					riskAssessmentDate: response.riskAssessmentDate,
					dateAdded: response.dateAdded,
					lastUpdate: response.lastUpdate,
					companyName: response.companyName,
					symbol: response.symbol,
					status: response.status,
				}
			};
		case CREATE_SETTLEMENTRATES_FAILURE:
			return {
				...state,
				new_settlementRate_error: action.error
			};

		case SETTLEMENTRATE_UPDATE:
			return {
				...state,
				UpdateDandOResult: action.UpdateDandOResult
			};
		default:
			return state
	}
};


export default reducerDandO;


// WEBPACK FOOTER //
// ./src/components/SettlementRate/redux/reducers.js